export default __webpack_public_path__ + "static/media/51791b8875546209.9cbb4e5af4c72c476d97283ff8ab7859.svg";